import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import withRemoteConfig from 'Utils/withRemoteConfig';

function SuspendedScreen ({ config }) {
  const isSuspended = config?.isMaintenanceMwOn === 'true';
  const isClient = process.env.BROWSER;

  useEffect(() => {
    if (isSuspended && isClient) {
      document.documentElement.classList.add('prevent-scroll');
    }

    return () => {
      if (isSuspended && isClient) {
        document.documentElement.classList.remove('prevent-scroll');
      }
    };
  }, [isSuspended]);

  if (!isSuspended) {
    return null;
  }

  return (
    <div className="suspended-screen">
      <div className="suspended-screen__inner">
        <img src="/public/images/bilyoner-logo-white.svg" alt="Bilyoner" className="suspended-screen__logo" />
        <Icon iconName="svgRenovation" className="suspended-screen__icon" />
        <p className="suspended-screen__description">
            Sizlere daha iyi hizmet verebilmek için bakımdayız. Lütfen biraz sonra tekrar deneyin.
        </p>
      </div>
    </div>
  );
}

SuspendedScreen.propTypes = {
  config: PropTypes.object,
};

export default withRemoteConfig(SuspendedScreen);
